import React from 'react';
import ColorPicker from 'polyphony/components/generic/colorpicker';
import {isPostEditor} from 'polyphony/util';
import {prefixCSS} from 'polyphony/css';

const svgs = {
    justify: <svg viewBox="0 0 448 512" width={22} height={22}><path fill="currentColor" d={"M0 84V44c0-8.837 7.163-16 16-16h416c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16zm16 144h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0-128h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"} /></svg>,
    yOverflow: <svg viewBox="0 0 256 512" width={22} height={22}><path fill="currentColor" d={"M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"} /></svg>,
    xOverflow: <svg viewBox="0 0 512 512" width={22} height={22}><path fill="currentColor" d={"M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"} /></svg>,
    icon: <svg viewBox="0 0 448 512" width={22} height={22}><path fill="currentColor" d={"M448 312v136c0 17.7-14.3 32-32 32H280c-13.3 0-24-10.7-24-24v-15.3c0-13.5 11.2-24.4 24.7-24l66.3 1.9-123-123-123 123 66.3-1.9c13.5-.4 24.7 10.5 24.7 24V456c0 13.3-10.7 24-24 24H32c-17.7 0-32-14.3-32-32V312c0-13.3 10.7-24 24-24h15.3c13.5 0 24.4 11.2 24 24.7L61.4 379l123-123-123-123 1.9 66.3c.4 13.5-10.5 24.7-24 24.7H24c-13.3 0-24-10.7-24-24V64c0-17.7 14.3-32 32-32h136c13.3 0 24 10.7 24 24v15.3c0 13.5-11.2 24.4-24.7 24L101 93.4l123 123 123-123-66.3 1.9c-13.5.4-24.7-10.5-24.7-24V56c0-13.3 10.7-24 24-24h136c17.7 0 32 14.3 32 32v136c0 13.3-10.7 24-24 24h-15.3c-13.5 0-24.4-11.2-24-24.7l1.9-66.3-123 123 123 123-1.9-66.3c-.4-13.5 10.5-24.7 24-24.7H424c13.3 0 24 10.7 24 24z"} /></svg>,
    elementIcon: <svg viewBox="0 0 448 512" height={22} width={22}><path fill="currentColor" d="M391.7 329.7L356 365.4 246.6 256 356 146.6l35.7 35.7c20.7 20.7 56.3 6 56.3-23.3V65c0-18.2-14.8-33-33-33h-94c-29.3 0-44.1 35.5-23.3 56.3l35.7 35.7L224 233.4 114.6 124l35.7-35.7C171 67.6 156.3 32 127 32H33C14.8 32 0 46.8 0 65v94c0 29.3 35.5 44.1 56.3 23.3L92 146.6 201.4 256 92 365.4l-35.7-35.7C35.6 309 0 323.7 0 353v94c0 18.2 14.8 33 33 33h94c29.3 0 44.1-35.5 23.3-56.3L114.6 388 224 278.6 333.4 388l-35.7 35.7c-20.7 20.7-6 56.3 23.3 56.3h94c18.2 0 33-14.8 33-33v-94c0-29.3-35.6-44.1-56.3-23.3zM321 60.9h94c2.3 0 4.1 1.9 4.1 4.1v94c0 3.7-4.4 5.5-7 2.9l-94-94c-2.6-2.6-.8-7 2.9-7zm-285.1 101c-2.6 2.6-7 .8-7-2.9V65c0-2.3 1.9-4.1 4.1-4.1h94c3.7 0 5.5 4.4 2.9 7l-94 94zM127 451.1H33c-2.3 0-4.1-1.9-4.1-4.1v-94c0-3.7 4.4-5.5 7-2.9l94 94c2.6 2.6.8 7-2.9 7zm288 0h-94c-3.7 0-5.5-4.4-2.9-7l94-94c2.6-2.6 7-.8 7 2.9v94c.1 2.3-1.8 4.1-4.1 4.1z" /></svg>,
    wrap: wrap => <svg viewBox="0 0 512 512"><path fill={wrap ? "white" : "currentColor"} d="M512 256c0 88.224-71.775 160-160 160H170.067l34.512 32.419c9.875 9.276 10.119 24.883.539 34.464l-10.775 10.775c-9.373 9.372-24.568 9.372-33.941 0l-92.686-92.686c-9.373-9.373-9.373-24.568 0-33.941l92.686-92.686c9.373-9.373 24.568-9.373 33.941 0l10.775 10.775c9.581 9.581 9.337 25.187-.539 34.464L170.067 352H352c52.935 0 96-43.065 96-96 0-13.958-2.996-27.228-8.376-39.204-4.061-9.039-2.284-19.626 4.723-26.633l12.183-12.183c11.499-11.499 30.965-8.526 38.312 5.982C505.814 205.624 512 230.103 512 256zM72.376 295.204C66.996 283.228 64 269.958 64 256c0-52.935 43.065-96 96-96h181.933l-34.512 32.419c-9.875 9.276-10.119 24.883-.539 34.464l10.775 10.775c9.373 9.372 24.568 9.372 33.941 0l92.686-92.686c9.373-9.373 9.373-24.568 0-33.941l-92.686-92.686c-9.373-9.373-24.568-9.373-33.941 0L306.882 29.12c-9.581 9.581-9.337 25.187.539 34.464L341.933 96H160C71.775 96 0 167.776 0 256c0 25.897 6.186 50.376 17.157 72.039 7.347 14.508 26.813 17.481 38.312 5.982l12.183-12.183c7.008-7.008 8.786-17.595 4.724-26.634z" /></svg>,
    boxSizing: isBorderBox => <svg viewBox="0 0 512 512" width={22} height={22}><path fill="currentColor" d="M448 64v384H64V64z" /><path fill={isBorderBox ? "currentColor" : "hsla(0, 0%, 0%, 0.27)"} d="M0 0v512h512V0zm448 448H64V64h384z" /></svg>
};
const FlexBox = ({gutenberg:{isEditor, setProp}, children, ...flexState}) => {
    if (!isEditor) {
        const {wrap, ...fs} = flexState;
        let css = {...fs, display: 'flex', flexWrap: wrap ? 'wrap' : 'nowrap'};
        return <div style={prefixCSS(css)}>{children}</div>;
    }

    const { InspectorControls, BlockControls } = wp.blockEditor;
    const { RangeControl, ToggleControl, DropdownMenu, Toolbar, TextControl } = wp.components;

    const flexSetter = k => v => setProp(k, v);

    let {
        // Dimensions
        width, minWidth, maxWidth, height, minHeight, maxHeight,

        // Margins
        marginTop, marginBottom, marginLeft, marginRight,

        // Padding
        paddingTop, paddingBottom, paddingLeft, paddingRight,

        // Colors
        color, backgroundColor,

        // Misc
        borderRadius, lineHeight, boxSizing,

        // FlexBox
        order, flexBasis, flexGrow, flexShrink
    } = flexState;

    const opt = (attr, value, title, icon = undefined) => ({
        title, icon,
        isDisabled: flexState[attr] === value,
        onClick: () => setProp(attr, value)
    });

    return (
        <>
            <InspectorControls>
                <h2>Dimensions</h2>
                <TextControl label="Width" className='polyphony-third-left' value={width} onChange={flexSetter('width')} />
                <TextControl label="Minimum" className='polyphony-third-center' value={minWidth} onChange={flexSetter('minWidth')} />
                <TextControl label="Maximum" className='polyphony-third-right' value={maxWidth} onChange={flexSetter('maxWidth')} />
                <TextControl label="Height" className='polyphony-third-left' value={height} onChange={flexSetter('height')} />
                <TextControl label="Minimum" className='polyphony-third-center' value={minHeight} onChange={flexSetter('minHeight')} />
                <TextControl label="Maximum" className='polyphony-third-right' value={maxHeight} onChange={flexSetter('maxHeight')} />

                <hr style={{margin: "0.5em 0"}}/>

                <h2>Margins</h2>
                <TextControl label="Top" className='polyphony-half-left' value={marginTop} onChange={flexSetter('marginTop')} />
                <TextControl label="Bottom" className='polyphony-half-right' value={marginBottom} onChange={flexSetter('marginBottom')} />
                <TextControl label="Left" className='polyphony-half-left' value={marginLeft} onChange={flexSetter('marginLeft')} />
                <TextControl label="Right" className='polyphony-half-right' value={marginRight} onChange={flexSetter('marginRight')} />

                <hr style={{margin: "0.5em 0"}}/>

                <h2>Padding</h2>
                <TextControl label="Top" className='polyphony-half-left' value={paddingTop} onChange={flexSetter('paddingTop')} />
                <TextControl label="Bottom" className='polyphony-half-right' value={paddingBottom} onChange={flexSetter('paddingBottom')} />
                <TextControl label="Left" className='polyphony-half-left' value={paddingLeft} onChange={flexSetter('paddingLeft')} />
                <TextControl label="Right" className='polyphony-half-right' value={paddingRight} onChange={flexSetter('paddingRight')} />

                <hr style={{margin: "0.5em 0"}}/>

                <h2>Flex Element</h2>
                <p>These controls require the parent block to be a FlexBox to work correctly.</p>
                <RangeControl
                    label="Order"
                    min={0}
                    help="Specifies the order of the FlexElement in a parent FlexElement."
                    value={order}
                    onChange={flexSetter('order')} />
                <ToggleControl
                    checked={flexBasis !== 'auto' && !!flexBasis}
                    label="Redistribute Space?"
                    onChange={() => setProp('flexBasis', flexBasis === 'auto' || !flexBasis ? 1 : 'auto')} />
                {flexBasis !== "auto" && !!flexBasis && <TextControl
                    label="Basis"
                    help="How much of a Flex element's space is redistributed."
                    value={flexBasis}
                    onChange={flexSetter('flexBasis')} /> }
                {flexBasis !== "auto" && !!flexBasis && <TextControl
                    label="Growing Precedence"
                    help="Larger values make the block take up more space than its siblings."
                    value={flexGrow}
                    onChange={flexSetter('flexGrow')} />}
                {flexBasis !== "auto" && !!flexBasis && <TextControl
                    label="Shrinking Precedence"
                    help="Larger values make the block take up less space than its siblings."
                    value={flexShrink}
                    onChange={flexSetter('flexShrink')} />}

                <hr style={{margin: "0.5em 0"}}/>

                <h2>Foreground Color</h2>
                <ColorPicker color={color} onChange={flexSetter('color')} />

                <hr style={{margin: "0.5em 0", marginTop: '1.5em'}}/>

                <h2>Background Color</h2>
                <ColorPicker color={backgroundColor} onChange={flexSetter('backgroundColor')} />

                <hr style={{margin: "0.5em 0", marginTop: '1.5em'}}/>

                <h2>Border Radius</h2>
                <RangeControl value={borderRadius} min={0} onChange={flexSetter('borderRadius')} />

                <hr style={{margin: "0.5em 0", marginTop: '1.5em'}}/>

                <h2>Text</h2>
                <TextControl label="Line Height" value={lineHeight} onChange={flexSetter('lineHeight')} />
            </InspectorControls>
            <BlockControls>
                <Toolbar>
                    <DropdownMenu
                        icon="image-rotate"
                        label="Wrap"
                        controls={[
                            opt('wrap', true, 'Wrap'),
                            opt('wrap', false, 'Don\'t Wrap')
                        ]}
                    />
                    <DropdownMenu
                        icon="move"
                        label="Direction"
                        controls={[
                            opt('flexDirection', 'column-reverse', 'Column (Reverse)', 'arrow-up-alt'),
                            opt('flexDirection', 'column', 'Column', 'arrow-down-alt'),
                            opt('flexDirection', 'row-reverse', 'Row (Reverse)', 'arrow-left-alt'),
                            opt('flexDirection', 'row', 'Row', 'arrow-right-alt')
                        ]}
                    />
                    <DropdownMenu
                        icon={svgs.justify}
                        label="Justify"
                        controls={[
                            opt('justifyContent', 'flex-start', 'Start'),
                            opt('justifyContent', 'flex-end', 'End'),
                            opt('justifyContent', 'center', 'Center'),
                            opt('justifyContent', 'space-between', 'Space Between'),
                            opt('justifyContent', 'space-around', 'Space Around'),
                            opt('justifyContent', 'space-evenly', 'Space Evenly')
                        ]}
                    />
                    <DropdownMenu
                           icon="sort"
                           label="Align Self"
                           controls={[
                               opt('alignSelf', 'auto', 'Automatic'),
                               opt('alignSelf', 'stretch', 'Stretch'),
                               opt('alignSelf', 'flex-start', 'Start'),
                               opt('alignSelf', 'flex-end', 'End'),
                               opt('alignSelf', 'center', 'Center'),
                               opt('alignSelf', 'baseline', 'Baseline')
                           ]}
                        />
                    <DropdownMenu
                       icon="sort"
                       label="Align Items"
                       controls={[
                           opt('alignItems', 'stretch', 'Stretch'),
                           opt('alignItems', 'flex-start', 'Start'),
                           opt('alignItems', 'flex-end', 'End'),
                           opt('alignItems', 'center', 'Center')
                       ]}
                    />
                    <DropdownMenu
                        icon="sort"
                        label="Align Content"
                        controls={[
                            opt('alignContent', 'flex-start', 'Start'),
                            opt('alignContent', 'flex-end', 'End'),
                            opt('alignContent', 'center', 'Center'),
                            opt('alignContent', 'stretch', 'Stretch'),
                            opt('alignContent', 'space-between', 'Space Between'),
                            opt('alignContent', 'space-around', 'Space Around')
                        ]}
                    />
                    <DropdownMenu
                        icon={svgs.yOverflow}
                        label="Y Overflow"
                        controls={[opt("overflowY", 'hidden', "Hidden"),
                                   opt('overflowY', 'visible', "Visible"),
                                   opt("overflowY", "auto", "Scroll if Necessary"),
                                   opt("overflowY", "scroll", "Always Scroll")]} />
                    <DropdownMenu
                        icon={svgs.xOverflow}
                        label="X Overflow"
                        controls={[opt("overflowX", 'hidden', "Hidden"),
                                   opt('overflowX', 'visible', "Visible"),
                                   opt("overflowX", "auto", "Scroll if Necessary"),
                                   opt("overflowX", "scroll", "Always Scroll")]} />
                    <DropdownMenu
                           icon={svgs.boxSizing(boxSizing === 'border-box')}
                       label="Box Sizing"
                       controls={[
                           opt('boxSizing', 'content-box', 'Content Box'),
                           opt('boxSizing', 'border-box', 'Border Box')
                       ]}
                    />
                </Toolbar>
            </BlockControls>
            {children}
        </>
    );
};

FlexBox.title = "FlexBox";
FlexBox.slug = 'flexbox';
FlexBox.icon = svgs.icon;
FlexBox.category = 'layout';
FlexBox.keywords = ['flex', 'box', 'flexbox'];
FlexBox.deprecated = [{
    support: {
        html: false
    },
    attributes: {
        state: {
            default: '{}',
            type: 'string'
        }
    },
    save({attributes}) {
        const {InnerBlocks} = window.wp.blockEditor;
        let {wrap, ...flex} = JSON.parse(attributes.state);
        return <div style={{...flex,
                            display: 'flex',
                            flexWrap: wrap ? 'wrap' : 'nowrap'}}><InnerBlocks.Content /></div>;
    }
}];
polyphony.addBlock(FlexBox);

if (isPostEditor()) {
    const { createBlock, registerBlockType } = wp.blocks;
    const {InnerBlocks} = window.wp.blockEditor;
    registerBlockType('polyphony/flexelement', {
        title: "FlexElement (Deprecated)",
        icon: svgs.elementIcon,
        category: 'layout',
        keywords: ['flex', 'element', 'flexelement'],
        parent: ['polyphony/flexbox'],
        transforms: {
            to: [
                {
                    type: 'block',
                    blocks: [ 'polyphony/flexbox' ],
                    transform: (atts, innerBlocks) => createBlock('polyphony/flexbox', atts, innerBlocks)
                }
            ]
        },
        support: {
            html: false
        },
        attributes: {
            state: {
                default: '{}',
                type: 'string'
            }
        },
        save({attributes}) {
            let {wrap, ...flex} = JSON.parse(attributes.state);
            return <div style={{...flex,
                                display: 'flex',
                                flexWrap: wrap ? 'wrap' : 'nowrap'}}><InnerBlocks.Content /></div>;
        },
        edit: () => <InnerBlocks />
    });
}
